// 工单状态
export enum ORDER_STATUS {
    /** 待处理 */
    WAITING = 0,
    /** 处理中 */
    PROCESSING = 1,
    /** 已解决 */
    SOLVED = 2,
    /** 已关闭 */
    CLOSED = 3,
    /** 已结束 */
    ENDED = 4
}

// 工单场景分类
export enum ORDER_SCENE {
    /** 产研工单 */
    PRODUCT_DEVELOPMENT = 1,
    /** erp工单 */
    ERP = 2,
    /** 客服工单 */
    CUSTOMER_SERVICE = 3,
    /** 发货工单 */
    DELIVERY = 4,
    /** 用户咨询工单 */
    CUSTOMER_CONSULTATION = 5,
    STORE_SERVICE = 6
}

/** 责任主体 */
// export enum RESPONSIBILITY_SUBJECT {
//     /** 平台 */
//     PLATFORM = 0,
//     /** 用户 */
//     USER = 1,
//     /** 商家 */
//     MERCHANT = 2,
//     /** 双方无责 */
//     BOTH_NO_FAULT = 3,
//     /** 平台及商家 */
//     PLATFORM_AND_MERCHANT = 4
// }

export enum ORDER_LEVEL {
    P0 = 0,
    P1,
    P2,
    P3
}

export enum DUTY_TYPE {
    /** 其他 */
    OTHER = 0,
    /** 商家 */
    MERCHANT = 1,
    /** 平台 */
    PLATFORM = 2,
    /** 用户 */
    USER = 3,
    /** 双方无责 */
    BOTH_NO_FAULT = 4,
    /** 双方有责 */
    BOTH_FAULT = 5
}

export enum IDENTITY_ROLE_CODE {
    /* 掌大导师 */
    ZD_TUTOR = 1,
    /** 掌大商家运营 */
    ZD_MERCHANT_OPERATION = 2,
    /** 掌上大学 */
    ZD_UNIVERSITY = 3,
    /** 校内员工 */
    CAMPUS_EMPLOYEE = 4,
    /** 掌大商家 */
    ZD_MERCHANT = 5,
    /** 掌大实习生 */
    ZD_INTERN = 6,
    /** 校园代理 */
    CAMPUS_AGENT = 7,
    /** 掌大集市路演 */
    ZD_MARKET_ROADSHOW = 8,
    /** 掌大售后客服 */
    ZD_AFTER_SALES_SERVICE = 9
}
